<template>

    <div class="stories__carousel__container">

        <div v-for="(story, index) in stories" class="stories__carousel__item" :style="getBackgroundImage(index)" @click="selectStory(story)">

            <p class="stories__carousel__title">{{ getYear(story) }}</p>

            <p class="stories__carousel__text">{{ getMonth(story) }}</p>

        </div>

    </div>

</template>

<script>

import I18n from '@/modules/i18n'

export default {

    name: 'stories-stats',

    props: {

        stories: {
            type: Array,
            default: () => []
        }

    },

    methods: {

        selectStory(story) {

            this.$emit('select', story)
        },

        getYear(story) {
            return story.date.split('-')[1]
        },

        getMonth(story) {
            const date = new Date()
            const monthNumber = story.date.split('-')[0]
            date.setMonth(monthNumber - 1)
            const month = date.toLocaleString(I18n.get(this), {month: 'long'})
            return month.charAt(0).toUpperCase() + month.slice(1)
        },

        getBackgroundImage(index) {
            return `background-image: url('${this.stories[index].thumbnail}');`
        }

    }

}

</script>

<style scoped lang="scss">

    .stories {
        &__carousel {
            &__container {
                display: flex;
                flex-direction: row;
                margin-bottom: 24px;
                overflow: scroll;
            }

            &__item {
                min-width: 128px;
                height: 184px;
                margin: 0 4px;
                border-radius: 12px;
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-content: start;
                padding: 12px;
                color: black;
                background-color: $blue;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }

            &__title {
                font-size: 12px;
                line-height: 115%;
                color: $white;
                letter-spacing: 0.04em;
            }

            &__text {
                font-size: 17px;
                line-height: 115%;
                letter-spacing: 0.02em;
                color: $white;
            }
        }
    }
</style>
